//引入接口文档
import req from '@/utils/req.js'


//通过类型获取微信应用信息
export function wechatType(params) {
    return req.get("/admin/wechat-app/type", params);
}
//获取公众号列表（客服）
export function wechatTypeNew(params) {
    return req.get("/admin/wechat-app/type/ascription", params);
}
//创建菜单
export function creatWechatMenu(params) {
    return req.post("/dsicm-contact-platform/feign/wechat-menu-button", params);
}
//删除菜单 
export function delAllMenu(params) {
    return req.delete(`/dsicm-contact-platform/feign/wechat-menu-button?publicId=${params}`, {});
}
//获取公众号菜单
export function wechatMenu(params) {
    return req.get(`/dsicm-contact-platform/feign/wechat-menu-button/${params}`, {});
}

//获取用户列表
export function userList(params) {
    return req.get("/dsicm-contact-platform/wechat-public-user/public-id", params);
}
//获取聊天列表
export function messageList(params) {
    return req.post("/dsicm-contact-platform/feign/wechat-private-message/page", params);
}
//发送私信
export function sendMessage(params) {
    return req.put("/dsicm-contact-platform/feign/wechat-private-message/send", params);
}
//获取未读消息
export function unreadMessage(params) {
    return req.get("/dsicm-contact-platform/feign/wechat-private-message/unread/message", params);
}